export default "__VITE_ASSET__eKLYnxJA__"